import { render, staticRenderFns } from "./AbkOfferMatchingProfilesTab.vue?vue&type=template&id=9ac819e2&scoped=true&"
import script from "./AbkOfferMatchingProfilesTab.vue?vue&type=script&lang=js&"
export * from "./AbkOfferMatchingProfilesTab.vue?vue&type=script&lang=js&"
import style0 from "./AbkOfferMatchingProfilesTab.vue?vue&type=style&index=0&id=9ac819e2&lang=scss&scoped=true&"
import style1 from "./AbkOfferMatchingProfilesTab.vue?vue&type=style&index=1&id=9ac819e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac819e2",
  null
  
)

export default component.exports